export default "__VITE_ASSET__CTtnDRRj__"